import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Approach from "../pages/approach/page";
import Projects from "../pages/projects/page";
import Contact from "../pages/contact/page";
import ResidentialProjects from "../pages/services/residential/page";
import CommercialProjects from "../pages/services/commercial/page";
import SpecialProjects from "../pages/services/special/page";
import Blog from "../pages/blog/page";
import MinimalistMimariTasarimIlkeleri from "../pages/blog/minimalist-mimari-tasarim-ilkeleri/page";
import DogalIsikMimarideMetkanAlgisi from "../pages/blog/dogal-isik-mimaride-mekan-algisi/page";
import SurdurulebilirMimariGelecek from "../pages/blog/surdurulebilir-mimari-gelecek/page";
import ModernKonutTasarimindaFonksiyon from "../pages/blog/modern-konut-tasariminda-fonksiyon/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hakkinda",
    element: <About />,
  },
  {
    path: "/mimari-yaklasim",
    element: <Approach />,
  },
  {
    path: "/projeler",
    element: <Projects />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/blog/minimalist-mimari-tasarim-ilkeleri",
    element: <MinimalistMimariTasarimIlkeleri />,
  },
  {
    path: "/blog/dogal-isik-mimaride-mekan-algisi",
    element: <DogalIsikMimarideMetkanAlgisi />,
  },
  {
    path: "/blog/surdurulebilir-mimari-gelecek",
    element: <SurdurulebilirMimariGelecek />,
  },
  {
    path: "/blog/modern-konut-tasariminda-fonksiyon",
    element: <ModernKonutTasarimindaFonksiyon />,
  },
  {
    path: "/iletisim",
    element: <Contact />,
  },
  {
    path: "/hizmetler/konut-projeleri",
    element: <ResidentialProjects />,
  },
  {
    path: "/hizmetler/ticari-alanlar",
    element: <CommercialProjects />,
  },
  {
    path: "/hizmetler/ozel-projeler",
    element: <SpecialProjects />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;